/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * The speech to text provider to use for batch transcription. Supported providers: 'gladia', 'deepgram', 'assemblyai', 'speechmatics', 'soniox'.
 */
export type RetranscribeBotBodyAnyOfTranscriptionProvider =
  (typeof RetranscribeBotBodyAnyOfTranscriptionProvider)[keyof typeof RetranscribeBotBodyAnyOfTranscriptionProvider]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RetranscribeBotBodyAnyOfTranscriptionProvider = {
  gladia: "gladia",
  deepgram: "deepgram",
  assemblyai: "assemblyai",
  speechmatics: "speechmatics",
  soniox: "soniox"
} as const
